import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from "redux-persist";
import storage from 'redux-persist/lib/storage';
import * as Reducers from "./reducers";
import createSagaMiddleware from 'redux-saga';
import sagas from './sagas';

const { authentication, ...reducers } = Reducers;

// Configuring redux persist
const rootPersistConfig = {
  key: "root",
  storage,
  blacklist: ["authentication"],
  whitelist: ["authentication", "config"]
};

const authPersistConfig = {
  key: "authentication",
  storage: storage,
  blacklist: ["isLoading", "ExpiredSessionModal"]
};

// Combine reducers
const rootReducer = combineReducers({
  authentication: persistReducer(authPersistConfig, authentication),
  ...reducers
});
// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Create the store
const persistedReducer = persistReducer(rootPersistConfig, rootReducer);
const store = configureStore({
  reducer: persistedReducer,
  middleware: [sagaMiddleware],
});

// Run sagas
sagaMiddleware.run(sagas);
persistStore(store);
export default store;
